import { render, staticRenderFns } from "./SectionWhyChooseUs.vue?vue&type=template&id=ab002aa8&"
import script from "./SectionWhyChooseUs.vue?vue&type=script&lang=js&"
export * from "./SectionWhyChooseUs.vue?vue&type=script&lang=js&"
import style0 from "./SectionWhyChooseUs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports